




































import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { CommonTabMixin } from "./mixins";
import { ManagerReference } from "../../../../domain/workflow/items";

@Component
export default class ManagersHistoryTab extends Mixins(CommonTabMixin) {

  toManagersNames(reference: ManagerReference): string[] {
    if (!this.existManager(reference)) { return new Array("未指定"); }
    return Enumerable.from(reference.managers)
      .orderBy(m => m.displayOrder)
      .select(m => m.staff.name).toArray();
  }

  toManagerClassName(reference: ManagerReference): string {
    return (!this.existManager(reference)) ? "no-manager" : "";
  }

  private existManager(reference: ManagerReference): boolean {
    return (reference.managers && 0 < reference.managers.length);
  }
}
